import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/kuroco.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as appUpdate from './utils/appUpdate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// New builds wait in the service worker until appUpdate decides it is safe to swap
// (docs/2026-10-18_PWA_update_flow.md). onUpdate fires when a new worker finishes
// installing while this page is open; start() also picks up one already waiting.
serviceWorkerRegistration.register({ onUpdate: appUpdate.onWaiting });
appUpdate.start();
